import type { GameSummary, TournamentInfo } from '@tanky/shared';
import { h } from '../dom';

/** „3 kola“, „5 kol“. */
export function roundsText(n: number): string {
  return `${n} ${n >= 2 && n <= 4 ? 'kola' : 'kol'}`;
}

/** Krátký popis režimu hry pro seznamy („🏆 Turnaj 2/5“). */
export function modeLabel(g: Pick<GameSummary, 'settings' | 'tournament'>): string | null {
  if (g.settings.mode === 'deathmatch') return '💥 Deathmatch';
  if (g.settings.mode !== 'tournament') return null;
  const rounds = g.tournament?.rounds ?? g.settings.rounds ?? 3;
  return g.tournament ? `🏆 Turnaj ${g.tournament.round}/${rounds}` : `🏆 Turnaj na ${roundsText(rounds)}`;
}

/** Průběžné pořadí turnaje. */
export function standingsTable(t: TournamentInfo, colorOf: (id: string) => string | undefined, me: string): HTMLElement {
  return h(
    'div',
    { class: 'table-wrap' },
    h(
      'table',
      { class: 'stats-table compact standings' },
      h(
        'thead',
        {},
        h(
          'tr',
          {},
          h('th', {}, '#'),
          h('th', { class: 'name' }, 'Hráč'),
          h('th', { title: 'Body za umístění v kolech' }, 'Body'),
          h('th', { title: 'Vyhraná kola' }, 'Výhry'),
          h('th', { title: 'Škody soupeřům celkem' }, 'Škody'),
        ),
      ),
      h(
        'tbody',
        {},
        ...t.standings.map((s, i) =>
          h(
            'tr',
            { class: s.id === me ? 'me' : '' },
            h('td', {}, String(i + 1)),
            h('td', { class: 'name' }, h('a', { href: `#/player/${s.id}`, style: { color: colorOf(s.id) ?? 'inherit' } }, s.name)),
            h('td', {}, h('b', {}, String(s.points))),
            h('td', {}, String(s.wins)),
            h('td', {}, String(s.damage)),
          ),
        ),
      ),
    ),
  );
}
